export const POSTER_PNG_URL = "/affiche-generale.jpg";

export const POSTER_PDF_DRIVE_URL =
  "https://drive.google.com/file/d/1PGv-HHhXEl-L4pKilttgv3_g1zpupjHG/view?usp=sharing";

export const CITY_POSTER_PDF_URL =
  "https://drive.google.com/drive/folders/1PLX8_35_SSTbn1YmP39IxuAFRFVi0Swf?usp=sharing";
